var map = {
	"./Unicauca_logo.png": 3161,
	"./Unir_logo.png": 3052,
	"./aws_logo.png": 4129,
	"./comsoc_logo.png": 8406,
	"./davies_logo.png": 9156,
	"./deeplearning_ai_logo.png": 2862,
	"./harvard_logo.png": 9110,
	"./ibm_logo.png": 9561,
	"./ingetel_logo.png": 8350,
	"./ipscambio_logo.png": 6425,
	"./javeriana_logo.png": 8161,
	"./mac_logo.png": 7858,
	"./microsoft_logo.png": 7231,
	"./mitx_logo.png": 9698,
	"./mongo_logo.png": 2251,
	"./platzi_logo.png": 8571,
	"./profile_photo_2.png": 5468,
	"./scrum_logo.png": 2249,
	"./servagro_logo.png": 6951,
	"./skalotek_logo.png": 3703,
	"./utp_logo.png": 9445,
	"./wharton_logo.png": 2708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1106;